/**
 * SECTION — GLOBAL CONTACT TABS
 *
 * Switches between the "calendar" and "form" panels (aria-selected + hidden).
 * Progressive enhancement: without JS the switch is hidden and both panels
 * stack (CSS via html.no-js), so the form is always reachable.
 */
(function () {
  'use strict';

  // Subject pills are checkboxes (multi-select). Without JS they submit as
  // contact[Sujet][] (array fallback); with JS we drop those names and post a
  // single hidden contact[Sujet] with the checked values joined by " / ".
  function initSubjects(section) {
    var boxes = section.querySelectorAll('.contact-subject-radio');
    if (!boxes.length) return;
    var form = boxes[0].closest('form');
    if (!form) return;

    var hidden = document.createElement('input');
    hidden.type = 'hidden';
    hidden.name = 'contact[Sujet]';
    form.appendChild(hidden);

    function sync() {
      var picked = [];
      boxes.forEach(function (box) {
        if (box.checked) picked.push(box.value);
      });
      hidden.value = picked.join(' / ');
    }

    boxes.forEach(function (box) {
      box.removeAttribute('name');
      box.addEventListener('change', sync);
    });
    sync();
  }

  function init() {
    var sections = document.querySelectorAll('[data-contact-tabs]');

    sections.forEach(function (section) {
      initSubjects(section);

      var tabs = section.querySelectorAll('[data-contact-tab]');
      var panels = section.querySelectorAll('[data-contact-panel]');
      if (!tabs.length || !panels.length) return;

      function activate(name) {
        tabs.forEach(function (tab) {
          var on = tab.dataset.contactTab === name;
          tab.classList.toggle('is-active', on);
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (panel) {
          panel.hidden = panel.dataset.contactPanel !== name;
        });
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          activate(tab.dataset.contactTab);
        });
      });

      // Foot notes can switch to the other panel (reuses activate()). Move focus
      // to the activated tab so keyboard users land on the new panel.
      section.querySelectorAll('[data-contact-tab-link]').forEach(function (link) {
        link.addEventListener('click', function () {
          var name = link.dataset.contactTabLink;
          activate(name);
          var tab = section.querySelector('[data-contact-tab="' + name + '"]');
          if (tab) tab.focus();
        });
      });

      // After a contact submit, surface the form panel so its confirmation /
      // error message is visible — UNLESS the submit was a slot booking (all
      // slot forms share form_type 'contact'), in which case we stay on the
      // booking panel and hide the form's stray success note.
      var justPosted = window.location.search.indexOf('contact_posted') !== -1;
      var formNote = section.querySelector('[data-contact-panel="form"] .contact-form-note');
      if (window.__bowsSlotJustBooked) {
        if (formNote) formNote.hidden = true;
      } else if (justPosted || formNote) {
        activate('form');
        // Native #contact_form scroll fails while the panel is hidden — do it now.
        if (formNote) formNote.scrollIntoView({ block: 'center' });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
